'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* globals window */
/* eslint-disable no-var, import/no-mutable-exports */

/**
* Universal Configuration Manager
*
* Manages both __application__ configuration and __Roc__ configuration.
* On the server the configurations will be fetched directly and on the client it's expected that the configuration
* is available on `window` as `ROC_CONFIG` and `APP_CONFIG`.
*
* appConfig will only contain what has been selected by `runtime.configWhitelistProperty`. That means if you want
* to read the full configuration on the server you will need to read it directly from node-config.
*/

/**
* Important to use "var" here over "const" since this might run in PhantomJS
* that does not support them, basically this needs to be ES5.
*/

var rocConfig = exports.rocConfig = function getRocConfig() {
    return typeof window !== 'undefined' ? window.ROC_CONFIG : require('roc').getSettings(); // eslint-disable-line
}();

var appConfig = exports.appConfig = function getAppConfig() {
    return typeof window !== 'undefined' ? window.APP_CONFIG : whiteListed();
}();

function whiteListed() {
    return rocConfig.runtime.configWhitelistProperty ? require('config')[rocConfig.runtime.configWhitelistProperty] // eslint-disable-line
    : undefined;
}
//# sourceMappingURL=universal-config.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/roc-package-web-app-react/lib/app/shared/universal-config.js
 ** module id = 1320
 ** module chunks = 1
 **/